import { Popover } from 'antd';
import { useState } from 'react';
import { IconAvatarArrowDown } from '@/assets/static/icons';
import '../profile-dropdown.style.css';
import { ProfileContent } from './profile-content';
import { useProfile } from '../hooks/use-profile-dropdown';
import { AppAvatar } from '@components/app-avatar';
import { useUserGuideStore } from '@shared/store/user-guide.store';

export function ProfileDropdownContainer() {
  const { userName, profileUrl } = useProfile();
  const { isTourProfileDropdownOpen, setTourProfileDropdownOpen } = useUserGuideStore();
  const [open, setOpen] = useState(false);
  return (
    <div>
      <Popover
        content={<ProfileContent closeDropdown={() => setOpen(false)} />}
        destroyOnHidden
        trigger="click"
        placement="bottomRight"
        arrow={false}
        className="p-0"
        rootClassName="logout__popover"
        open={open || isTourProfileDropdownOpen}
        onOpenChange={(v) => {
          setOpen(v);
          if (!v) setTourProfileDropdownOpen(false);
        }}
      >
        <div className="cursor-pointer relative flex">
          <AppAvatar src={profileUrl} className="size-9! border-gray-500!" name={userName} />
          <IconAvatarArrowDown className="absolute top-[22px] right-0" />
        </div>
      </Popover>
    </div>
  );
}
